import { HTMLRenderer } from "shared/components/atoms/HTMLRenderer";
import { TextSkeleton } from "shared/components/atoms/TextSkeleton";

interface Props {
  selfIntroduction: string | undefined;
}

export const SelfIntroduction = ({ selfIntroduction }: Props) => {
  return (
    <>
      <h2 tw="font-base text-base leading-7 tracking-[.47px]">プロフィール</h2>
      <div tw="mt-5">
        {selfIntroduction ? (
          <HTMLRenderer tw="font-light text-sm tracking-[.5] text-black whitespace-pre-wrap">
            {selfIntroduction}
          </HTMLRenderer>
        ) : (
          <TextSkeleton tw="mb-4" />
        )}
      </div>
    </>
  );
};
